import React from "react";
import ReactDOM from "react-dom/client";

import { RootLayout } from "./layout";
import { RootRoute } from "./routes";
import "./index.scss";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <React.StrictMode>
        <RootLayout>
            <RootRoute />
        </RootLayout>
    </React.StrictMode>
);
